import * as THREE from 'three';

export const TOF_EFFECT_BASE_SIZE = 0.25;

export const createTofPyramidMaterial = () => new THREE.MeshBasicMaterial({
  color: 0xef4444,
  transparent: true,
  opacity: 0.2,
  depthWrite: true,
  side: THREE.DoubleSide,
  polygonOffset: true,
  polygonOffsetFactor: 1,
  polygonOffsetUnits: 1,
});

const createTofPyramidEdgeGeometry = () => {
  const geometry = new THREE.BufferGeometry();
  geometry.setAttribute('position', new THREE.Float32BufferAttribute(new Array(15).fill(0), 3));
  geometry.setIndex([
    0, 1,
    0, 2,
    0, 3,
    0, 4,
    1, 2,
    2, 3,
    3, 4,
    4, 1,
  ]);
  return geometry;
};

export const createTofPyramidEdges = () => {
  const edges = new THREE.LineSegments(
    createTofPyramidEdgeGeometry(),
    new THREE.LineBasicMaterial({
      color: 0x991b1b,
      depthTest: true,
      depthWrite: false,
      transparent: true,
    }),
  );
  edges.renderOrder = 1;
  return edges;
};

export const createTofRay = (
  sensorPanel: THREE.Object3D | null | undefined,
  mazeAnchor: THREE.Object3D | null,
  robotRoot: THREE.Object3D | null,
) => {
  const orientation = mazeAnchor ?? robotRoot;
  if (!sensorPanel || !orientation) return null;
  sensorPanel.updateWorldMatrix(true, true);
  orientation.updateWorldMatrix(true, false);
  const sensorBounds = new THREE.Box3().setFromObject(sensorPanel);
  const origin = sensorBounds.isEmpty()
    ? sensorPanel.getWorldPosition(new THREE.Vector3())
    : sensorBounds.getCenter(new THREE.Vector3());
  const direction = new THREE.Vector3(0, -1, 0)
    .applyQuaternion(orientation.getWorldQuaternion(new THREE.Quaternion()))
    .normalize();
  return { origin, direction };
};

export const createTofBaseCorners = (
  origin: THREE.Vector3,
  direction: THREE.Vector3,
  distance: number,
): THREE.Vector3[] => {
  const halfSize = TOF_EFFECT_BASE_SIZE / 2;
  const baseCenter = origin.clone().addScaledVector(direction, distance);
  const right = new THREE.Vector3(direction.y, -direction.x, 0).normalize();
  const up = new THREE.Vector3(0, 0, 1);

  return [
    baseCenter.clone().addScaledVector(right, -halfSize).addScaledVector(up, -halfSize),
    baseCenter.clone().addScaledVector(right, halfSize).addScaledVector(up, -halfSize),
    baseCenter.clone().addScaledVector(right, halfSize).addScaledVector(up, halfSize),
    baseCenter.clone().addScaledVector(right, -halfSize).addScaledVector(up, halfSize),
  ];
};